import { abi } from "./abi";
import {
  GAS_INCREASE,
} from "./const";
import {
  CONTRACTADDRESS,
  PRICE,
  WHITE_LIST_NUM,
  WHITE_LIST_PRICE
} from "./configuration";
import { getMintStatus ,getWhiteListMintStatus} from "./status";
import { getTree } from "./merkleTree";
import { transactionHostURL } from "./util";

const formatMintTransaction = async (data) => {
  const web3 = data.state.web3;
  const address = data.state.address;
  const chainId = Number(data.state.chainId);
  const count = data.state.mintAmout;
  const targetContract = CONTRACTADDRESS[chainId][0];
  var contract = new web3.eth.Contract(abi, targetContract);
  let extraData;

  extraData = await contract.methods.mint(count);

  let input = extraData.encodeABI();
  const finalPrice = count * PRICE;
  const estimatedGas = await web3.eth.estimateGas({
    from: address,
    data: input,
    to: targetContract,
    value: web3.utils.toWei(finalPrice.toString(), "ether"),
  });
  const nonce = await web3.eth.getTransactionCount(address, "latest");
  return {
    gas: parseInt(estimatedGas * GAS_INCREASE),
    to: targetContract,
    from: address,
    value: web3.utils.toWei(finalPrice.toString(), "ether"),
    data: web3.utils.toHex(input),
    nonce,
  };
};

export const MintTransaction = async (data) => {
  if (!data.state.web3) {
    return;
  }

  if (data.state.mintErrorMsg) {
    data.setState({
      mintErrorMsg: "",
    });
  }

  try {
    const tx = await formatMintTransaction(data);
    function sendTransaction(_tx) {
      return new Promise((resolve, reject) => {
        data.state.web3.eth
          .sendTransaction(_tx)
          .once("transactionHash", (txHash) => resolve(txHash))
          .catch((err) => reject(err));
      });
    }
    const result = await sendTransaction(tx);
    data.setState({
      txn: result,
      pendingRequest: true,
      modalDialogBodyHref: `${transactionHostURL(
        data.state.chainId
      )}/${result}`,
      modalDialogBodyText:
        "You have approved the transaction, please don't close the dialog until your transaction completes successfully.",
    });
    const interval = setInterval(function () {
      data.state.web3.eth.getTransactionReceipt(result, function (err, rec) {
        if (rec) {
          clearInterval(interval);
          data.setState({
            finish: true,
            pendingRequest: false,
            modalDialogBodyHref: `${transactionHostURL(
              data.state.chainId
            )}/${result}`,
            modalDialogBodyText: `Successfully minted CryptoAngel!`,
          });
        }
      });
    }, 1000);
  } catch (error) {
    console.error("CATCHERROR", error.message);
    data.setState({
      modalDialogBodyText:error.message,

    });
    var myRe = /{.*}/g;
    var str = error.message.replace(/(\r\n|\n|\r)/gm, "");
    var errArray = myRe.exec(str);
    if (errArray && errArray.length > 0) {
      if (JSON.parse(errArray[0]).originalError.message) {
        const errorDetails = JSON.parse(errArray[0]).originalError.message;
        data.setState({
          mintErrorMsg: errorDetails,
          modalDialogBodyText:errorDetails,

        });
      } else {
        data.setState({
          mintErrorMsg: error.message,
          modalDialogBodyText:error.message,
        });
      }
    } else {
      data.setState({
        mintErrorMsg: error.message,
        modalDialogBodyText:error.message,
      });
    }
  }
};

export const MintToWhiteList = async (data) => {
  if (!data.state.web3) {
    return;
  }

  if (data.state.mintErrorMsg) {
    data.setState({
      mintErrorMsg: "",
    });
  }

  try {
    const tx = await formatMintToWhiteListTransaction(data);
    function sendTransaction(_tx) {
      return new Promise((resolve, reject) => {
        data.state.web3.eth
          .sendTransaction(_tx)
          .once("transactionHash", (txHash) => resolve(txHash))
          .catch((err) => reject(err));
      });
    }
    const result = await sendTransaction(tx);
    data.setState({
      txn: result,
      pendingRequest: true,
      modalDialogBodyHref: `${transactionHostURL(
        data.state.chainId
      )}/${result}`,
      modalDialogBodyText:
        "You have approved the transaction, please don't close the dialog until your transaction completes successfully.",
    });
    const interval = setInterval(function () {
      data.state.web3.eth.getTransactionReceipt(result, function (err, rec) {
        if (rec) {
          clearInterval(interval);
          data.setState({
            finish: true,
            pendingRequest: false,
            modalDialogBodyHref: `${transactionHostURL(
              data.state.chainId
            )}/${result}`,
            modalDialogBodyText: `Successfully minted CryptoAngel!`,
          });
        }
      });
    }, 1000);
  } catch (error) {
    console.error("CATCHERROR", error.message);
    data.setState({
      modalDialogBodyText:error.message,

    });
    var myRe = /{.*}/g;
    var str = error.message.replace(/(\r\n|\n|\r)/gm, "");
    var errArray = myRe.exec(str);
    if (errArray && errArray.length > 0) {
      if (JSON.parse(errArray[0]).originalError.message) {
        const errorDetails = JSON.parse(errArray[0]).originalError.message;
        data.setState({
          mintErrorMsg: errorDetails,
          modalDialogBodyText:errorDetails,

        });
      } else {
        data.setState({
          mintErrorMsg: error.message,
          modalDialogBodyText:error.message,
        });
      }
    } else {
      data.setState({
        mintErrorMsg: error.message,
        modalDialogBodyText:error.message,
      });
    }
  }
};

const formatMintToWhiteListTransaction = async (data) => {
  const web3 = data.state.web3;
  const address = data.state.address;
  const chainId = Number(data.state.chainId);
  getTree(data)
  const count = WHITE_LIST_NUM;
  const proof = data.state.proof;
  const targetContract = CONTRACTADDRESS[chainId][0];
  var contract = new web3.eth.Contract(abi, targetContract);
  let extraData;

  extraData = await contract.methods.mintToWhiteList(address,count,proof);
  let input = extraData.encodeABI();
  const finalPrice = count * WHITE_LIST_PRICE;
  const estimatedGas = await web3.eth.estimateGas({
    from: address,
    data: input,
    to: targetContract,
    value: web3.utils.toWei(finalPrice.toString(), "ether"),
  });
  const nonce = await web3.eth.getTransactionCount(address, "latest");
  return {
    gas: parseInt(estimatedGas * GAS_INCREASE),
    to: targetContract,
    from: address,
    value: web3.utils.toWei(finalPrice.toString(), "ether"),
    data: web3.utils.toHex(input),
    nonce,
  };
};